module.exports = __webpack_public_path__ + "stellarwp-logo-dcabae63a9c4c96d1b68f1fd950ee381.webp";